import { ExternalTracker } from '@/@types/graphql-types';

const MACRO_TIMESTAMP = /\[(timestamp)]/i;
const MACRO_GDPR_CONSENT = '${GDPR}' as const;

type FormatMacroImpressionType = {
	tracker: string;
	hasConsent?: boolean;
};

/**
 *
 * Formatting an impression tracker, that may include impressions or clickout URL
 *
 * At the moment, the trackers are only fired if consent is given,
 * so we can safely assume that this replacement is set to '1'.
 *
 * @param impression {number} a URL with the included [timestamp] macro
 * @param hasConsent {boolean} if user has given GDPR consent
 *
 * @returns a formatted tracker
 */

export const formatExternalTracker = ({ tracker, hasConsent = true }: FormatMacroImpressionType) => {
	tracker = tracker.replace(MACRO_TIMESTAMP, Date.now().toString());
	tracker = tracker.replace(MACRO_GDPR_CONSENT, hasConsent ? '1' : '0');

	return tracker;
};

/**
 * Loop through all our external tracker urls, allowing us to
 * have multiple trackers
 *
 * @param externalTrackers
 */
export const handleExternalClickoutTrackers = (externalTrackers: ExternalTracker[]) => {
	externalTrackers.forEach(({ data }) => {
		if (data) {
			// TODO: if env variable is not production, handle the URLs differently
			const url = formatExternalTracker({
				tracker: data,
			});

			try {
				fetch(url, {
					mode: 'no-cors',
				});
			} catch (err: any) {}
		}
	});
};

/**
 * Inject external HTML trackers into the body of the page
 *
 * @param externalTrackers
 */
export const injectExternalHtmlTrackers = (externalTrackers: ExternalTracker[]) => {
	externalTrackers.forEach(({ data }) => {
		if (data) {
			const formatImpression = formatExternalTracker({ tracker: data });
			const fragment = document.createRange().createContextualFragment(formatImpression);

			document.head.appendChild(fragment);
		}
	});
};
